import React from 'react';
import './consent-form.css';
import { useTranslation } from 'react-i18next';
import { routePaths } from '../../core/navigation/route-paths';

type Props = {
  onAgreeConsentForm: () => void;
};

const ConsentCookieForm: React.FC<Props> = (props) => {
  const { t } = useTranslation(['common']);

  const onLinkPress = () => {
    window.location.replace(`${routePaths.Policies}`);
  };

  return (
    <div className="consent-form">
      <div className="m-4">
        <h3 className="consent-content">{t('common.consentFormTitle')}</h3>
        <button
          className="btn v2 btn-primary mt-3"
          type="button"
          onClick={props.onAgreeConsentForm}
        >
          {/* {t('home.learn_more')} */}
          <span className="txt-buttom-link">{t('common.iAgree')}</span>
        </button>
        <div className="text-dark-custom custom-link mt-2" onClick={onLinkPress}>
          {t('common.readOurPolicesAndTerms')}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ConsentCookieForm);
